import { post } from '@namespace/helpers';
import { IApiResponse } from '../../../types';

interface IExcludedPrewagerGamesListResponse {
  gameIds: number[];
}

export const excludedPrewagerGamesList = (
  slug: string
): Promise<IApiResponse<IExcludedPrewagerGamesListResponse>> => {
  return post('/service/GM/public/game-list', {
    slug
  });
};
